/**
 * It's a generated file, preferable to extend this in external file
 */
import * as yup from 'common/yup';
import {DiplomatObject} from './DiplomatObject';
import {enums} from './enums';

export const pagingSettingsSchema = DiplomatObject.shape({
   pagingType: yup.string().oneOf(enums.pagertype.keys),
   reportingLevel: yup.string().oneOf(enums.reportingLevel.keys),
   emailAddress: yup.string(),
   emailSubject: yup.string(),
   useCustomMessage: yup.boolean(),
   primaryLocation: yup.string(),
   secondaryLocation: yup.string(),
   filename: yup.string(),
   pin: yup.string(),
   messageLength: yup.number().integer(),
   messageTemplate: yup.string(),
});
export type PagingSettings = yup.InferType<typeof pagingSettingsSchema>;
